import * as React from "react";
import { useEffect, useRef } from "react";
const Checkbox = ({
  checked = void 0,
  children = void 0,
  className = void 0,
  disabled = void 0,
  id = void 0,
  indeterminate = false,
  inline = false,
  name = void 0,
  onChange,
  onClick = void 0,
  readOnly = void 0,
  title = void 0,
  value = void 0,
  defaultChecked = void 0,
  "aria-describedby": ariaDescribedBy = void 0,
  "aria-labelledby": ariaLabelledBy = void 0,
  "aria-label": ariaLabel = void 0
}, forwardedRef) => {
  const internalRef = useRef(null);
  const checkboxRef = forwardedRef || internalRef;
  useEffect(() => {
    if (checkboxRef.current && checkboxRef.current.indeterminate !== indeterminate) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [checkboxRef, indeterminate]);
  const label = /* @__PURE__ */ React.createElement("label", { className: inline ? `checkbox-inline ${className != null ? className : ""}` : void 0, title, htmlFor: id }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      ref: checkboxRef,
      id,
      defaultChecked,
      name,
      checked,
      disabled,
      readOnly,
      value,
      "aria-describedby": ariaDescribedBy,
      "aria-labelledby": ariaLabelledBy,
      "aria-label": ariaLabel,
      onClick,
      onChange
    }
  ), children);
  return inline ? label : /* @__PURE__ */ React.createElement("div", { className: `checkbox ${className != null ? className : ""}` }, label);
};
export default React.forwardRef(Checkbox);
